// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"e_l-","scoreNumber":"e_m-","scoreStars":"e_n-","badge":"e_o-","badgeImage":"e_p-"};